var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_431_4635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_431_4635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63636 8.44531H4.27273V13.8898H2.63636C1.73636 13.8898 1 13.1898 1 12.3342V10.0009C1 9.14531 1.73636 8.44531 2.63636 8.44531Z",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7273 8.44531H17.3637C18.2637 8.44531 19 9.14531 19 10.0009V12.3342C19 13.1898 18.2637 13.8898 17.3637 13.8898H15.7273V8.44531Z",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27271 8.44444C4.27271 5.43444 6.83361 3 9.99998 3C13.1663 3 15.7273 5.43444 15.7273 8.44444",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7272 13.8887C15.7272 15.6076 14.2627 16.9998 12.4545 16.9998H10.8181",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d04f7576f4910c9903a85e976ccd70d8.svg";
export { ForwardRef as ReactComponent };